# frozen_string_literal: true

module Engine
  module Game
    module G21Moon
    end
  end
end
